// extracted by mini-css-extract-plugin
module.exports = {"callout":"Q7eoSTGb+O7QXpdNj56ttw=="};